import React from "react";

export default function StoryCard({ userStories, onClick, isOwn, hasUnseen }) {
  const { user } = userStories;

  // Show first name under the story; fall back to username or name
  const displayName = isOwn
    ? "My Vibe"
    : user?.first_name || user?.username || user?.name || "Unknown";

  const getInitials = (u) => {
    if (!u) return "?";
    const first = u.first_name || u.name || u.username || "";
    const last = u.last_name || "";
    const a = first ? first.charAt(0) : "";
    const b = last ? last.charAt(0) : (u.username ? u.username.charAt(0) : "");
    return (a + b).toUpperCase() || "?";
  };

  const profileSrc = user?.picture || null;

  return (
    <div className={`story_card_circle ${hasUnseen ? 'unseen' : 'seen'}`} onClick={onClick} role="button" tabIndex={0} onKeyPress={(e)=>{ if(e.key==='Enter') onClick&&onClick(); }}>
      <div className="story_ring">
        <div className="story_avatar">
          {profileSrc ? (
            <img src={profileSrc} alt={user?.first_name || user?.username || 'profile'} />
          ) : (
            <div className="avatar_fallback">{getInitials(user)}</div>
          )}
        </div>
      </div>

      <div className="story_profile_name small_name" title={displayName}>
        {displayName}
      </div>
    </div>
  );
}
